<template>
  <div></div>
</template>

<script>
import * as turf from "@turf/turf";

export default {
  name: "HeatMap",
  props: {
    pointData: {
      required: true // 点数据列表，需要geoJson: FutureCollection<Future<Point>>
    },
    map: {
      required: true // mapbox对象
    },
    dataPropertyName: {
      required: true // 属性字段名
    },
    layerId: {
      required: true,
    }
  },
  data() {
    return {
      dataRange: 0,
      dataMin: 0,
      dataMax: 0
    }
  },
  methods: {
    //初始化图层
    initLayer() {
      this.map.addSource(this.layerId, {
        type: "geojson",
        // 数据为mapbox官方数据
        // 可能访问不到或者跨域，本地测试时可以直接下下来
        data: this.pointData,
      });
      if (this.dataMin !== this.dataMax) {
        this.map.addLayer(
          {
            'id': this.layerId,
            'type': 'heatmap',
            'source': this.layerId,
            'paint': {
              // 根据频率和属性大小增加热力图权重
              "heatmap-weight": [
                "interpolate",
                ["linear"],
                ["get", "pValue"],
                this.dataMin, 0,
                this.dataMax, 1,
              ],
              // 根据缩放级别增加热力图权重
              // heatmap-intensity 是热力图权重的乘数
              "heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 0, 1, 9, 3],
              // 色带
              "heatmap-color": [
                "interpolate",
                ["linear"],
                ["heatmap-density"],
                0,
                "rgba(33,102,172,0)",
                0.2,
                "#AEB8EA",
                0.4,
                "#B3FA3E",
                0.6,
                "#F1FB2E",
                0.8,
                "#FBA92E",
                1,
                "#FB312E",
              ],
              // 根据缩放级别调整热力图半径
              "heatmap-radius": ["interpolate", ["linear"], ["zoom"], 0, 10, 9, 40],
              // 透明度
              // "heatmap-opacity": ["interpolate", ["linear"], ["zoom"], 0, 1, 9, 1],
              "heatmap-opacity": 1,
            }
          }, 'polygonLayer')
      } else {
        this.map.addLayer(
          {
            'id': this.layerId,
            'type': 'heatmap',
            'source': this.layerId,
            'paint': {
              // 根据频率和属性大小增加热力图权重
              "heatmap-weight": 1,
              // 根据缩放级别增加热力图权重
              // heatmap-intensity 是热力图权重的乘数
              "heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 0, 1, 9, 3],
              // 色带
              "heatmap-color": [
                "interpolate",
                ["linear"],
                ["heatmap-density"],
                0,
                "rgba(33,102,172,0)",
                0.2,
                "#AEB8EA",
                0.4,
                "#B3FA3E",
                0.6,
                "#F1FB2E",
                0.8,
                "#FBA92E",
                1,
                "#FB312E",
              ],
              // 根据缩放级别调整热力图半径
              "heatmap-radius": ["interpolate", ["linear"], ["zoom"], 0, 2, 9, 20],
              // 透明度
              // "heatmap-opacity": ["interpolate", ["linear"], ["zoom"], 0, 1, 9, 1],
              "heatmap-opacity": 1,
            }
          }, 'polygonLayer')
      }
      this.mapFitBoundary(this.pointData)
    },

    mapFitBoundary(geo) {
      const bbox = turf.bbox(geo)
      this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
        linear: false,
        animate: true,
        padding: {top: 120, bottom: 130, left: 190, right: 500},
      })
    },

    removeLayer() {
      if (this.map.getLayer(this.layerId)) {
        this.map.removeLayer(this.layerId)
      }
      if (this.map.getLayer('HeatMap-point')) {
        this.map.removeLayer('HeatMap-point')
      }
      if (this.map.getSource(this.layerId)) {
        this.map.removeSource(this.layerId)
      }
    },
  },
  mounted() {
    //获取Pvalue的最大最小值
    let max = Number.MIN_VALUE;
    let min = Number.MAX_VALUE;
    turf.featureEach(this.pointData, (currentPoint) => {
      max = Math.max(max, currentPoint.properties[this.dataPropertyName]);
      min = Math.min(min, currentPoint.properties[this.dataPropertyName]);
    });
    this.dataRange = (max - min) / 5;
    this.dataMin = min;
    this.dataMax = max
    //初始化图层
    this.initLayer();
  },
  destroyed() {
    this.removeLayer()
  },
}
</script>

<style scoped>

</style>
